module.exports = __webpack_public_path__ + "static/media/logo-rafa-ori.62abb2aa.png";